import { Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { Source } from '../../models/source.model';
import { SourceTypeEnum } from '../../../../api/source/enums/source-type.enum';
import { SourceGroup } from '../../models/source-group.model';
import { SourceService } from '../../services/source.service';
import { SourceGroupService } from '../../services/source-group.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ChipModel } from '@Common/Forms/models/chip.model';


@Component({
    selector: 'agpr-edit-source-dialog',
    styleUrls: ['./edit-source-dialog.component.scss'],
    templateUrl: './edit-source-dialog.component.html',
    standalone: false
})
export class EditSourceDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input() source: Source;
    @Input() existingGroups: SourceGroup[];

    sourceName: string;
    sourceType: SourceTypeEnum;

    nameErrors: string[] = [];
    groupList$: Observable<SourceGroup[]>;

    existingGroupsChips: ChipModel[] = [];
    addToGroupsChips: ChipModel[] = [];

    private groupsToRemove: SourceGroup[] = [];
    private groupsToAdd: SourceGroup[] = [];

    readonly buttonTypes = ButtonTypesEnum;
    readonly sourceTypes = SourceTypeEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        private sourceService: SourceService,
        private sourceGroupService: SourceGroupService
    ) {
        super(coreDialogService, 'EditSourceDialog');
    }

    ngOnInit(): void {
        this.sourceName = this.source.name;
        this.sourceType = this.source.type;
        this.groupList$ = this.sourceGroupService.all$;

        if (this.existingGroups) {
            this.existingGroupsChips = this.existingGroups.map(group => {
                return {
                    id: group.id,
                    label: group.name
                };
            });
        }
    }

    validateName() {
        this.nameErrors = [];

        if (!this.sourceName.trim()) {
            this.nameErrors.push('Sources.error.emptyName');
        }

        this.sourceService.isNameDuplicated$(this.sourceName, this.source.id).subscribe(
            isDuplicate => {
                if (isDuplicate) {
                    this.nameErrors.push('Sources.error.duplicate');
                }
            }
        );
    }

    removeExistingGroup(chip: ChipModel) {
        this.existingGroupsChips = this.existingGroupsChips.filter(x => x !== chip);

        const group = this.existingGroups?.find(x => x.id === chip.id);
        if (group) {
            this.groupsToRemove.push(group);
        }
    }

    addNewGroup(group: SourceGroup) {
        if (this.groupsToAdd.find(x => x.id === group.id)) {
            return;
        }

        this.addToGroupsChips.push({
            id: group.id,
            label: group.name
        });
        this.groupsToAdd.push(group);
    }

    removeNewGroup(chip: ChipModel) {
        this.addToGroupsChips = this.addToGroupsChips.filter(x => x !== chip);
        this.groupsToAdd = this.groupsToAdd.filter(group => group.id !== chip.id);
    }

    confirm() {
        if (this.nameErrors.length > 0) {

            return;
        }

        if (this.sourceName !== this.source.name || this.sourceType !== this.source.type) {
            this.source.name = this.sourceName;
            this.source.type = this.sourceType;
            this.sourceService.update(this.source).subscribe();
        }

        this.groupsToAdd.forEach(group => {
            group.sourceIds.push(this.source.id);
            this.sourceGroupService.update(group).subscribe();
        });

        this.groupsToRemove.forEach(group => {
            group.sourceIds = group.sourceIds.filter(groupId => groupId !== this.source.id);
            this.sourceGroupService.update(group).subscribe();
        });

        this.closeDialog();
    }

    cancel() {
        this.closeDialog();
    }
}
